/**
 * Packers route gate — lazy-loads one toolkit entry; mobile vs desktop locked on first mount.
 */
import React, { Suspense } from 'react';
import Loader from '../../components/Loader';
import { lazyWithChunkReload } from '../../utils/lazyWithChunkReload';

const PackersToolkitEntry = lazyWithChunkReload(() => import('./PackersToolkitEntry'));

export default function PackersRouteGate() {
    return (
        <Suspense fallback={<Loader />}>
            <PackersToolkitEntry />
        </Suspense>
    );
}
